"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = InvoicesSearch;
const react_1 = __importStar(require("react"));
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const InvoiceFilterBody_1 = require("./InvoiceFilterBody");
const InvoiceModalButtons_1 = require("./Modals/InvoiceModalButtons");
const InvoicesController_1 = require("./InvoicesController");
const InvoiceRowContent_1 = require("./InvoiceRowContent");
function InvoicesSearch({ title }) {
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    return (react_1.default.createElement(FilterableTable_1.default, { id: "invoices", title: title, FilterBodyComponent: InvoiceFilterBody_1.InvoicesFilterBody, searchOnMount: true, tableStructure: [
            // Wszystkie kolumny zeszły do jednego bloku faktury (makieta
            // `tmp/makieta-lista-faktur-v1.html`, wariant A, decyzja właściciela 2026-08-31):
            // „Numer”, „Dane faktury”, „Sprzedaż”, „Data wystawienia”, „Netto”, „Termin
            // płatności” i „Status”. Daty stoją teraz w jednej kolumnie bocznej bloku, bo
            // w wąskich kolumnach się zawijały.
            // colLg 11, nie 12: dwunasta kolumna zostaje wolna na RowActionMenu aktywnego
            // wiersza — powód opisany w LettersSearch.tsx.
            {
                header: "Faktura",
                renderTdBody: (invoice) => react_1.default.createElement(InvoiceRowContent_1.InvoiceRowContent, { invoice: invoice }),
                colLg: 11,
            },
        ], AddNewButtonComponents: [InvoiceModalButtons_1.InvoiceAddNewModalButton], EditButtonComponent: InvoiceModalButtons_1.InvoiceEditModalButton, isDeletable: (invoice) => !invoice.ksefNumber, isCopyable: true, repository: InvoicesController_1.invoicesRepository, selectedObjectRoute: "/invoice/" }));
}
